import React from 'react';
import { useNavigate } from 'react-router-dom';
import './SupportPage.css';
import { useEffect } from 'react';
import ContactFormWithMap from '../Footer/ContactFormWithMap';

const SupportPage = () => {
    const navigate = useNavigate();
    const userId = localStorage.getItem('userId');

    useEffect(() => {
        if (!userId) {
            navigate('/login');
        }
    }, [userId, navigate]);

    return (
        <div className="support-container" style={{ marginTop: '40px' }}>
            <ContactFormWithMap />
        </div>

    );
};

export default SupportPage;
